import { SxProp, View } from 'dripsy';
import React from 'react';
import { AmountSummary, AmountSummaryProps } from './AmountSummary';
import { space } from '@/design-system/baseTheme/styles/spacings';

interface AmountSummaryListProps {
  data: Array<AmountSummaryProps>;
  gap?: keyof typeof space;
  vertical?: boolean;
  showValue?: boolean;
  loading?: boolean;
}

export const AmountSummaryList: React.FC<AmountSummaryListProps> = (props) => {
  const { data, gap, vertical, showValue = true, loading } = props;

  const containerStyle = vertical ? styles.containerVertical : styles.containerHorizontal;
  return (
    <View sx={containerStyle}>
      {data.map((item, index) => (
        <React.Fragment key={`amount-summary-list-${item.label}-${index}`}>
          {index > 0 && vertical && <View sx={{ mt: gap }} />}
          {index > 0 && !vertical && <View sx={{ ml: gap }} />}
          <AmountSummary {...item} showValue={showValue} loading={loading} />
        </React.Fragment>
      ))}
    </View>
  );
};

enum StyleName {
  containerHorizontal = 'containerHorizontal',
  containerVertical = 'containerVertical'
}

const styles: Record<StyleName, SxProp> = {
  containerHorizontal: {
    flex: 1,
    flexDirection: 'row'
  },
  containerVertical: {
    flex: 1,
    flexDirection: 'column'
  }
};
